<template>
  <SingleColumn>
    <template #header>
      <h1 class="text-3xl font-bold text-white">
        Einstellungen
      </h1>
    </template>
    <template #content>
      <MenuPanel v-if="data">
        <template #items>
          <MenuPanelItem icon="UserIcon" :to="{name: 'settings.profile'}">
            Profil
          </MenuPanelItem>
          <MenuPanelItem icon="CameraIcon" :to="{name: 'settings.picture'}">
            Profilbild
          </MenuPanelItem>
          <MenuPanelItem icon="CogIcon" :to="{name: 'settings.account'}">
            Account
          </MenuPanelItem>
          <MenuPanelItem icon="KeyIcon" :to="{name: 'settings.password'}">
            Passwort
          </MenuPanelItem>
          <MenuPanelItem icon="SquaresPlusSolidIcon" :to="{name: 'settings.contract'}">
            Studio Upgrade
          </MenuPanelItem>
          <MenuPanelItem icon="TrashIcon" :to="{name: 'settings.delete'}">
            Account löschen
          </MenuPanelItem>
        </template>
        <template #main>
          <router-view>
          </router-view>
        </template>
      </MenuPanel>
    </template>
  </SingleColumn>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
const store = useStore();
const data = computed(() => store.getters['auth/user']);
</script>
